// frontend/src/hooks/useAppContext.ts

export interface AppContext {
    isMaster: boolean;
    isTenant: boolean;
    subdomain: string | null;
    appType: 'master' | 'tenant';
  }
  
  /**
   * Hook pour déterminer si l'application est en mode Master ou Tenant
   * 
   * @returns {AppContext} Contexte de l'application
   * 
   * @example
   * const { isMaster, subdomain } = useAppContext();
   * 
   * if (isMaster) {
   *   // Afficher le dashboard admin master
   * } else {
   *   // Afficher l'interface tenant avec subdomain
   * }
   */
  export const useAppContext = (): AppContext => {
    const hostname = window.location.hostname;
    
    // Détection du master
    // Master : legalchat.smartlawyer.ai ou localhost (dev)
    const isMaster = hostname === 'legalchat.smartlawyer.ai' || hostname === 'localhost';
    
    // Extraction du subdomain pour les tenants
    // Tenant : {subdomain}.smartlawyer.ai (ex: dupont.smartlawyer.ai)
    const subdomain = !isMaster && hostname.includes('.smartlawyer.ai')
      ? hostname.split('.')[0]
      : null;
    
    return {
      isMaster,
      isTenant: !isMaster,
      subdomain,
      appType: isMaster ? 'master' : 'tenant'
    };
  };